import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorsStore = defineStore('errors', () => {
  const showError = ref(false)
  const message = ref('')
  const variant = ref('danger')

  function showErrorMsg({ message: msg, variant: v }: { message: string; variant?: string }) {
    if (v) variant.value = v
    message.value = msg
    showError.value = true
  }

  function dismissError() {
    variant.value = 'danger'
    showError.value = false
    message.value = ''
  }

  return { showError, message, variant, showErrorMsg, dismissError }
})
